import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Catalog from './Catalog';
import React, { useState } from 'react';

export default function App() {
  return (
    <Router basename={"/catalogo"}>
      <Routes>
          <Route path="/" element={<Catalog />} />
        </Routes>
    </Router>
  );
}

